import { useState, useEffect } from "react";
//import { useDataProvider } from "react-admin";
import SFError from "../models/SfError";
import settings from "../utils/settings";

function useGenerateRegisterUrl() {
  const [url, setUrl] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  //const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      const { realmId, branchId } = settings();
      try {
        let data = {
          locale: "en-US",
          type: "client",
          client_id: process.env.REACT_APP_CLIENT_ID,
          client_secret: process.env.REACT_APP_CLIENT_SECRET,
        };
        const clientRawResult = await fetch(
          `${process.env.REACT_APP_OAUTH_ENDPOINT}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );
        const clientResult = await clientRawResult.json();
        // /security/otp
        let body = {
          form_code: "FORM:MEMBER:ONBOARD:SERVICE:2.0",
          realm_id: realmId,
        };
        if (branchId) {
          body.branch_id = branchId;
        }
        const result = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/onboard/subscribe/url/generate`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${clientResult.payload.access_token}`,
            },
            body: JSON.stringify(body),
          }
        );

        if (result.ok) {
          const jsonResult = await result.json();

          setUrl(jsonResult.payload.self_register_url);
          return setLoading(false);
        } else {
          const jsonResult = await result.json();
          const error = new SFError({
            status: result.status,
            code: jsonResult.code,
            message: jsonResult.message,
          });
          setError(error);
          return setLoading(false);
        }
        // const result = await dataProvider.create(
        //   "onboard/subscribe/url/generate",
        //   {
        //     data: { form_code: "FORM:MEMBER:ONBOARD:SERVICE:2.0" },
        //   }
        // );
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loading,
    error,
    url,
  };
}

export default useGenerateRegisterUrl;
